import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Label } from 'react-bootstrap';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Avatar from '../../Avatar';
import Link from '../../Link';

import { readMessage } from '../../../actions/message/readMessage';
import messages from '../../../locale/messages';

import s from '../Inbox.css';

const InboxItem = ({
	type,
	threadId,
	profileId,
	picture,
	displayName,
	content,
	createdAt,
	startDate,
	endDate,
	city,
	state,
	country,
	status,
	sentBy,
	read }) => {

	const account = useSelector(state => state.account.data);
	const dispatch = useDispatch();
	const { userId } = account;

	const label = (status, noStyle) => {
		let style, label;
		switch (status) {
			case 'inquiry':
				label = <FormattedMessage {...messages.messageStatus1} />
				style = 'info';
				break;
			case 'preApproved':
				label = <FormattedMessage {...messages.messageStatus2} />
				style = 'primary';
				break;
			case 'declined':
				label = <FormattedMessage {...messages.messageStatus3} />
				style = 'danger';
				break;
			case 'approved':
				label = <FormattedMessage {...messages.messageStatus4} />
				style = 'success';
				break;
			case 'pending':
				label = <FormattedMessage {...messages.messageStatus5} />
				style = 'warning';
				break;
			case 'cancelledByHost':
				label = <FormattedMessage {...messages.messageStatus6} />
				style = 'danger';
				break;
			case 'cancelledByGuest':
				label = <FormattedMessage {...messages.messageStatus7} />
				style = 'danger';
				break;
			case 'intantBooking':
				label = <FormattedMessage {...messages.messageStatus8} />
				style = 'success';
				break;
			case 'instantBooking':
				label = <FormattedMessage {...messages.messageStatus8} />
				style = 'success';
				break;
			case 'confirmed':
				label = <FormattedMessage {...messages.messageStatus8} />
				style = 'success';
				break;
			case 'expired':
				label = <FormattedMessage {...messages.messageStatus9} />
				style = 'danger';
				break;
			case 'requestToBook':
				label = <FormattedMessage {...messages.messageStatus10} />
				style = 'primary';
				break;
			case 'completed':
				label = <FormattedMessage {...messages.inboxCompleted} />
				style = 'success';
				break;
		}
		if (noStyle) {
			return label;
		}
		return <Label bsStyle={style}>{label}</Label>
	}

	let createdDate = createdAt != null ? moment(parseInt(createdAt)).format('MM/DD/YYYY') : '';
	let start = startDate != null ? '(' + moment(startDate).format('MM/DD/YYYY') : '';
	let end = endDate != null ? ' - ' + moment(endDate).format('MM/DD/YYYY') + ')' : '';
	let isRead;
	if (userId !== sentBy && read === false) {
		isRead = s.threadSubjectUnread;
	}

	return (
		<div className={s.listAvatarFlex}>
			<div className={cx(s.threadAvatar, 'inboxAvatar')}>
				<Avatar
					source={picture}
					height={75}
					width={75}
					title={displayName}
					className={s.profileAvatar}
					withLink
					linkClassName={s.profileAvatarLink}
					profileId={profileId}
				/>
			</div>
			<div className={cx(s.listDeatilsGrid, 'listingTagCurve grayBgCurve')}>
				<div>
					<Link to={"/users/show/" + profileId} className={cx(s.listTitle)}>
						{displayName}
					</Link>
					<p className={cx(s.cityText, s.noMargin)}>{createdDate}</p>
				</div>
				<div className={s.titleWidth}>
					{
						status === 'completed' || status === 'approved' || status === 'confirmed' || status === 'instantBooking' ? (
							<Link
								to={"/message/" + threadId + "/" + type}
								className={cx(s.listTitle, s.linkListTitle)}
								onClick={() => dispatch(readMessage(threadId, type))}
							>
								<div>
									<span className={cx({ [s.threadSubjectUnread]: userId !== sentBy && read === false, 'threadSubjectUnreadRTL': userId !== sentBy && read === false }, s.statusText)}>{content != null ? content : label(status, true)}</span>
									<p className={cx(s.linkDecoration, s.spaceTop10)}>{city}, {state}, {country}</p>
									<p className={cx(s.noMargin, s.linkDecoration)}>{start} {end}</p>
								</div>
							</Link>
						) : (
							<div>
								<span className={cx({ [s.threadSubjectUnread]: userId !== sentBy && read === false, 'threadSubjectUnreadRTL': userId !== sentBy && read === false }, s.statusText)}>{content != null ? content : label(status, true)}</span>
								<p className={cx(s.linkDecoration, s.spaceTop10)}>{city}, {state}, {country}</p>
								<p className={cx(s.noMargin, s.linkDecoration)}>{start} {end}</p>
							</div>
						)
					}

				</div>
				<div className={cx('messageStatus')}>
					{label(status)}
				</div>
			</div>
		</div>
	);
}

InboxItem.propTypes = {
	type: PropTypes.string.isRequired,
	status: PropTypes.string.isRequired,
	threadId: PropTypes.number.isRequired,
	profileId: PropTypes.number.isRequired,
	picture: PropTypes.string,
	displayName: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	createdAt: PropTypes.string.isRequired,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	sentBy: PropTypes.string.isRequired,
	city: PropTypes.string.isRequired,
	state: PropTypes.string.isRequired,
	country: PropTypes.string.isRequired,
	read: PropTypes.bool.isRequired,
	account: PropTypes.shape({
		userId: PropTypes.string.isRequired
	}),
	readMessage: PropTypes.any.isRequired
};

InboxItem.defaultProps = {
	createdAt: null,
	startDate: null,
	endDate: null,
	picture: null,
	status: null,
	sentBy: null,
	read: false
}
export default withStyles(s)(InboxItem);